import QrCode from "../../Service/QrCode";

const tpl = $("#tpl_now").text();

// ========= 收藏商品 单品详情页、历史价格查询页面会用到=========
function collection_operation(obj) {
  let id = $(obj).attr("id").substr(4);
  let request_url = $(obj).attr("url");
  let parent = $(obj).parent();
  parent.html('<a rel="nofollow" href="javascript:" title="收藏并获得降价、到货提醒" class="s keep favorite">正在收藏</a>');
  $.get("/collect/aj_add/?" + request_url, function (msg) {
    msg = JSON.parse(msg);
    if (msg.code == "2") {
      parent.html("收藏过了");
    } else if (msg.code == "1") {
      parent.html('<a id="fav_' + id + '" url="' + request_url + '" class="s keep favorite collected"><i class="icon i-clock red"></i>已收藏</a>');
      if (uid && is_wx_bind !== undefined && is_wx_bind == 0) {
        to_bind_wx(uid);
      }
    } else if (msg.code == "100") {
      parent.html('<a id="fav_' + id + '" url="' + request_url + '" class="wx-remind s keep favorite">\n' + '<i class="icon i-clock"></i>收藏并降价提醒\n' + "</a>");
      if (tpl == "trend") {
        $("#pop_mask, #pop_login").show();
        parent.find("a.s[id^=fav_]").on("click", function () {
          collection_operation(this);
        });
      } else {
        $(".pop_login").click();
        parent.find("a.s[id^=fav_]").on("click", function () {
          $(".pop_login").click();
        });
      }
    } else {
      parent.html('<a id="fav_' + id + '" url="' + request_url + '" class="wx-remind s keep favorite">\n' + '<i class="icon i-clock"></i>收藏并降价提醒\n' + "</a>");
      parent.find("a.s[id^=fav_]").on("click", function () {
        collection_operation(this);
      });
      alert("收藏出现问题，刷新下试试");
    }
  });
}
import utils from "../../js/utils/utils";
function collection_delete(obj) {
  let dp_id = $(obj).attr("id").substr(4);
  let request_url = $(obj).attr("url");
  let parent = $(obj).parent();
  parent.html('<a rel="nofollow" href="javascript:" title="收藏并获得降价、到货提醒" class="s keep favorite">正在取消收藏</a>');
  utils.HttpRequest.get(
    "https://i.gwdang.com/UserCollection/Detail",
    { dp_id },
    {
      isSign: true,
      ac: "UserCollection.Detail",
      crossDomain: true,
    }
  ).then(res => {
    if (res.code == 1) {
      utils.HttpRequest.post(
        "https://i.gwdang.com/UserCollection/Delete",
        { collection_ids: res.data.id },
        {
          isSign: true,
          ac: "UserCollection.Delete",
          crossDomain: true,
        }
      ).then(res => {
        if (res.code === 1) {
          parent.html('<a id="fav_' + dp_id + '" url="' + request_url + '" class="wx-remind s keep favorite">\n' + '<i class="icon i-clock"></i>收藏并降价提醒\n' + "</a>");
        }
      });
    }
  });
}

async function to_bind_wx(userid) {
  if ($(".popover-bindWX .content .qrcode img").length) {
    try {
      const url = await QrCode.getBindQrCode(userid);
      $(".popover-bindWX .content .qrcode img").attr("src", url);
      $(".popover-bindWX").addClass("active");
    } catch (e) {}
  }
}

$("#collectShop").click(function () {
  if (this.children[0].classList.contains("collected")) {
    collection_delete(this.children[0]);
  } else {
    collection_operation(this.children[0]);
  }
});

$(function () {
  $(".popover-bindWX .content .close").on("click", function () {
    console.log("close popup");
    $(".popover-bindWX").removeClass("active");
  });
});
